/**
 * Sections
 */
export const SET_SECTION = "SET_SECTION";
export const CREATE_SECTION = "CREATE_SECTION";
export const SECTIONS_RECIBIDOS = "SECTIONS_RECEIVED";
export const SET_PROPERTY_SECTION = "SET_PROPERTY_SECTION";
